<template>
  <!-- Header -->
  <header
    class="fixed top-0 left-0 right-0 z-40 h-[65px] bg-white shadow flex items-center justify-between sm:justify-end px-3">

    <!-- Notification Button -->
    <!-- <button @click="showNotifications = true"
      class="relative w-6 h-6 lg:w-7 lg:h-7 sm:mr-6 flex items-center justify-center text-gray-500 hover:text-[#CD7D00] transition">
      <i class="fa-solid fa-bell text-[24px]"></i>

      <span
        class="absolute -top-1 -right-1 bg-red-500 text-white text-[10px] font-semibold rounded-full w-4 h-4 flex items-center justify-center">
        3
      </span>
    </button> -->

    <!-- Cart block – matches screenshot -->
    <!-- <div className="flex items-center gap-2 text-sm text-gray-800 sm:mr-5 ">
      <div className="relative w-6 h-6 lg:w-7 lg:h-7">
        <img className="w-full h-full object-contain" src="../../assets/images/top2.png" alt="Cart Icon" />
        <span
          className="absolute -top-1 -right-1 bg-red-500 text-white text-[10px] font-semibold rounded-full w-4 h-4 flex items-center justify-center">
          2
        </span>
      </div>
      <div className="hidden leading-none lg:flex flex-col justify-center">
        <p className="text-black text-xs hover:font-bold cursor-pointer flex justify-center">Cart</p>
        <span className="text-xs text-gray-500">$283.00</span>
      </div>
    </div> -->

    <!-- User Info Text -->
    <div class="flex items-center gap-3">
      <div class="order-1 sm:order-0">
        <div class="text-sm font-semibold">{{ userName }}</div>
        <div class="text-xs text-gray-600">{{ userEmail }}</div>
      </div>

      <!-- User Icon -->
      <div class="w-9 h-9 rounded-full grid place-content-center ring-2 ring-[#CD7D00]/60 shadow-md shadow-[#CD7D00]/20
             order-0 sm:order-1">
        <i class="fa-solid fa-user text-[#CD7D00]"></i>
      </div>
    </div>


    <button @click="openDrawer"
      class="sm:hidden grid place-content-center w-9 h-9 rounded-md bg-gradient-to-r from-[#FFD200] to-[#CD7D00] text-white">
      <i class="fa-solid fa-bars"></i>
    </button>
  </header>



  <!-- Sidebar (desktop) -->
  <aside
    class="hidden md:block fixed left-0 top-0 z-50 w-[280px] h-screen overflow-y-auto shrink-0 border-r bg-[#F6F6F6]">
    <!-- sidebar content here -->
    <div class=" flex items-center justify-center font-rubik">
      <router-link to="/">
        <div class="flex items-center justify-center py-1 h-[55px] sm:h-[62px] w-[100px] sm:w-[150px] ">
          <img class="sm:object-contain" src="../../assets/images/logo-nav.png" alt="">
        </div>
      </router-link>
    </div>

    <!-- nav -->
    <nav class="p-3 space-y-4 font-medium">
      <router-link :to="{ name: 'account.dashboard' }" :class="getActiveClass('account.dashboard')"
        class="flex items-center p-2 text-gray-900 hover:text-white rounded-lg hover:bg-gradient-to-r from-[#FFD200] to-[#CD7D00] group">
        <div class="flex justify-between w-full items-center">
          <span class="ml-3 font-roboto">Dashboard</span>
          <i class="fas fa-home"></i>
        </div>
      </router-link>

      <router-link :to="{ name: 'account.shipments' }" :class="getActiveClass('account.shipments')"
        class="flex items-center p-2 text-gray-900 hover:text-white rounded-lg hover:bg-gradient-to-r from-[#FFD200] to-[#CD7D00] group">
        <div class="flex justify-between w-full items-center">
          <span class="ml-3 font-roboto">Shipments</span>
          <i class="fas fa-list"></i>
        </div>
      </router-link>

      <router-link :to="{ name: 'account.orders' }" :class="getActiveClass('account.orders')"
        class="flex items-center p-2 text-gray-900 hover:text-white rounded-lg hover:bg-gradient-to-r from-[#FFD200] to-[#CD7D00] group">
        <div class="flex justify-between w-full items-center">
          <span class="ml-3 font-roboto">Order History</span>
          <i class="fas fa-box"></i>
        </div>
      </router-link>

      <router-link :to="{ name: 'account.inquiries' }" :class="getActiveClass('account.inquiries')"
        class="flex items-center p-2 text-gray-900 hover:text-white rounded-lg hover:bg-gradient-to-r from-[#FFD200] to-[#CD7D00] group">
        <div class="flex justify-between w-full items-center">
          <span class="ml-3 font-roboto">Inquiries</span>
          <i class="fas fa-ticket-alt"></i>
        </div>
      </router-link>

      <router-link :to="{ name: 'account.addresses' }" :class="getActiveClass('account.addresses')"
        class="flex items-center p-2 text-gray-900 hover:text-white rounded-lg hover:bg-gradient-to-r from-[#FFD200] to-[#CD7D00] group">
        <div class="flex justify-between w-full items-center">
          <span class="ml-3 font-roboto">Addresses</span>
          <i class="fas fa-map-marker-alt"></i>
        </div>
      </router-link>

      <!-- <router-link :to="{ name: 'account.invoices' }" :class="getActiveClass('account.invoices')"
        class="flex items-center p-2 text-gray-900 hover:text-white rounded-lg hover:bg-gradient-to-r from-[#FFD200] to-[#CD7D00] group">
        <div class="flex justify-between w-full items-center">
          <span class="ml-3 font-roboto">Invoices</span>
          <i class="fas fa-file-invoice"></i>
        </div>
      </router-link> -->

      <template v-if="token">
        <a href="#" @click.prevent="logout"
          class="flex items-center p-2 text-gray-900 rounded-lg hover:text-white hover:bg-gradient-to-r from-[#FFD200] to-[#CD7D00] group">
          <div class="flex justify-between w-full items-center">
            <span class="ml-3 whitespace-nowrap font-roboto">Logout</span>
            <i class="fas fa-sign-in-alt"></i>
          </div>
        </a>
      </template>

      <template v-else>
        <router-link to="/login"
          class="flex items-center p-2 text-gray-900 rounded-lg hover:text-white hover:bg-gradient-to-r from-[#FFD200] to-[#CD7D00] group">
          <div class="flex justify-between w-full items-center">
            <span class="ml-3 whitespace-nowrap">Sign In</span>
            <i class="fas fa-sign-in-alt"></i>
          </div>
        </router-link>

        <router-link to="/signup"
          class="flex items-center p-2 text-gray-900 rounded-lg hover:text-white hover:bg-gradient-to-r from-[#FFD200] to-[#CD7D00] group">
          <i class="fas fa-user-plus"></i>
          <span class="ml-3 whitespace-nowrap">Sign Up</span>
        </router-link>
        <hr class="my-2" />
      </template>
    </nav>
  </aside>

  <!-- Every Page name  -->
  <!-- <div>
    <h1 class="ml-2 sm:ml-80 text-xl sm:text-2xl font-semibold font-nexa">Dashboard</h1>
  </div> -->

  <!-- Drawer (mobile) -->
  <transition name="slide">
    <div v-if="isDrawerOpen" class="fixed inset-0 z-50 md:hidden bg-black/40 backdrop-blur-sm">
      <!-- Click outside to close -->
      <div class="absolute inset-0" @click="closeDrawer"></div>

      <!-- Drawer Content -->
      <div class="relative w-[250px] h-full bg-[#F6F6F6] shadow-lg p-4 z-10 animate-slide-in">
        <button @click="closeDrawer" class="absolute top-3 right-3 text-[#CD7D00] text-xl">
          <i class="fa-solid fa-xmark"></i>
        </button>

        <nav class="mt-10 space-y-4 font-medium">
          <router-link :to="{ name: 'account.dashboard' }" :class="getActiveClass('account.dashboard')"
            class="flex items-center p-2 text-gray-900 hover:text-white rounded-lg hover:bg-gradient-to-r from-[#FFD200] to-[#CD7D00] group">
            <div class="flex justify-between w-full items-center">
              <span class="ml-3 font-roboto">Dashboard</span>
              <i class="fas fa-home"></i>
            </div>
          </router-link>

          <router-link :to="{ name: 'account.shipments' }" :class="getActiveClass('account.shipments')"
            class="flex items-center p-2 text-gray-900 hover:text-white rounded-lg hover:bg-gradient-to-r from-[#FFD200] to-[#CD7D00] group">
            <div class="flex justify-between w-full items-center">
              <span class="ml-3 font-roboto">Shipments</span>
              <i class="fas fa-list"></i>
            </div>
          </router-link>

          <router-link :to="{ name: 'account.orders' }" :class="getActiveClass('account.orders')"
            class="flex items-center p-2 text-gray-900 hover:text-white rounded-lg hover:bg-gradient-to-r from-[#FFD200] to-[#CD7D00] group">
            <div class="flex justify-between w-full items-center">
              <span class="ml-3 font-roboto">Order History</span>
              <i class="fas fa-box"></i>
            </div>
          </router-link>

          <router-link :to="{ name: 'account.inquiries' }" :class="getActiveClass('account.inquiries')"
            class="flex items-center p-2 text-gray-900 hover:text-white rounded-lg hover:bg-gradient-to-r from-[#FFD200] to-[#CD7D00] group">
            <div class="flex justify-between w-full items-center">
              <span class="ml-3 font-roboto">Inquiries</span>
              <i class="fas fa-ticket-alt"></i>
            </div>
          </router-link>

          <router-link :to="{ name: 'account.addresses' }" :class="getActiveClass('account.addresses')"
            class="flex items-center p-2 text-gray-900 hover:text-white rounded-lg hover:bg-gradient-to-r from-[#FFD200] to-[#CD7D00] group">
            <div class="flex justify-between w-full items-center">
              <span class="ml-3 font-roboto">Addresses</span>
              <i class="fas fa-map-marker-alt"></i>
            </div>
          </router-link>

          <router-link :to="{ name: 'account.invoices' }" :class="getActiveClass('account.invoices')"
            class="flex items-center p-2 text-gray-900 hover:text-white rounded-lg hover:bg-gradient-to-r from-[#FFD200] to-[#CD7D00] group">
            <div class="flex justify-between w-full items-center">
              <span class="ml-3 font-roboto">Invoices</span>
              <i class="fas fa-map-marker-alt"></i>
            </div>
          </router-link>

          <template v-if="token">
            <a href="#" @click.prevent="logout"
              class="flex items-center p-2 text-gray-900 rounded-lg hover:text-white hover:bg-gradient-to-r from-[#FFD200] to-[#CD7D00] group">
              <div class="flex justify-between w-full items-center">
                <span class="ml-3 whitespace-nowrap font-roboto">Logout</span>
                <i class="fas fa-sign-in-alt"></i>
              </div>
            </a>
          </template>

          <template v-else>
            <router-link to="/login"
              class="flex items-center p-2 text-gray-900 rounded-lg hover:text-white hover:bg-gradient-to-r from-[#FFD200] to-[#CD7D00] group">
              <div class="flex justify-between w-full items-center">
                <span class="ml-3 whitespace-nowrap">Sign In</span>
                <i class="fas fa-sign-in-alt"></i>
              </div>
            </router-link>

            <router-link to="/signup"
              class="flex items-center p-2 text-gray-900 rounded-lg hover:text-white hover:bg-gradient-to-r from-[#FFD200] to-[#CD7D00] group">
              <i class="fas fa-user-plus"></i>
              <span class="ml-3 whitespace-nowrap">Sign Up</span>
            </router-link>
            <hr class="my-2" />
          </template>
        </nav>
      </div>
    </div>
  </transition>

  <main class="md:ml-[280px] min-h-[calc(100vh-65px)] bg-white px-4 py-6 sm:px-6 lg:px-8 overflow-y-auto">
    <router-view />
  </main>
  <NotificationModal :show="showNotifications" @close="showNotifications = false" />

</template>


<script>
import NotificationModal from "@/components/Global/Modals/NotificationModal.vue";
export default {
  components: { NotificationModal },
  name: 'AuthLayout',
  props: {
    isOpen: { type: Boolean, default: false },
  },
  data() {
    return {
      token: null, isDrawerOpen: false, showNotifications: false,
    };
  },
  computed: {
    currentRoute() { return this.$route.name },
    userName() { return localStorage.getItem('name') || ''; },
    userEmail() { return localStorage.getItem('email') || ''; }
  },
  methods: {
    getActiveClass(routeName) {
      if (routeName === 'account.shipments' && this.$route.name && this.$route.name.startsWith('account.shipments')) {
        return 'sidebar_item_active';
      }
      return this.$route.name === routeName ? 'sidebar_item_active' : '';
    },
    logout() {
      localStorage.removeItem('token');
      localStorage.removeItem('name');
      localStorage.removeItem('email');
      this.$router.push({ name: "login" });
    },
    openDrawer() {
      this.isDrawerOpen = true;
    },
    closeDrawer() {
      this.isDrawerOpen = false;
    },
  },
  mounted() {
    this.token = localStorage.getItem('token');
  },
};
</script>

<style>
.sidebar_item_active {
  color: white !important;
  background: linear-gradient(to right bottom, #ffd200, #cd7d00);
}
</style>